module.exports = __webpack_public_path__ + "static/img/Matthias_Ebel.b93967c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Matthias_Ebel.jpg
// module id = V2tb
// module chunks = 2